const YearOfEducEnum = Object.freeze([{
    name: "Ato (Mr)",
    code: "ato",
}, {
    name: "W/ro (Mrs)",
    code: "wro",
}, {
    name: "W/rt (Ms)",
    code: "wrt",
}, {
    name: "DR",
    code: "dr",
},{
    name: "Prof",
    code: "prof",
},
    {
        name: "Sr",
        code: "sr",
    }
]);

export default YearOfEducEnum;
